import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';

/** Single source of the top-bar chip look: `chip` is the box at rest, `active` only swaps the colors, so the row never shifts. */
const navChipStyle = Object.freeze({
	chip: css`
		${theme.typography.chip}
		display: inline-flex;
		align-items: center;
		padding: 0.5rem 0.8125rem;
		border-radius: ${theme.radii.pill};
		text-decoration: none;
		white-space: nowrap;
		background-color: ${theme.appBar.navChip.background};
		color: ${theme.appBar.navChip.text};
		transition:
			background-color ${theme.motion.duration},
			color ${theme.motion.duration};

		&:focus-visible {
			outline: 2px solid ${theme.colors.accent};
			outline-offset: 2px;
		}
	`,
	active: css`
		background-color: ${theme.appBar.navChipActive.background};
		color: ${theme.appBar.navChipActive.text};
	`,
});

export default navChipStyle;
